/**
 * Lifecycle de la commande fournisseur.
 *
 * Depuis le découplage (Phase 3 — avril 2026), l'`etat` représente uniquement
 * le cycle de vie métier. La réception est désormais portée par un axe
 * parallèle (`EtatReception`).
 *
 * États actifs : EN_REDACTION → EN_ATTENTE_CONFIRMATION → EN_ATTENTE_LIVRAISON
 * → TERMINEE.
 *
 * Phase 4 : `SOLDEE` fusionné avec `TERMINEE` (la sous-livraison clôturée est
 * portée par `etatReception<>TOTAL`).
 */
export enum CommandeEtat {
  EN_REDACTION = "EN_REDACTION",
  /** @deprecated Phase 3 — orphelin (jamais assigné). Migré vers EN_REDACTION. */
  EN_ATTENTE_ENVOI = "EN_ATTENTE_ENVOI",
  EN_ATTENTE_CONFIRMATION = "EN_ATTENTE_CONFIRMATION",
  EN_ATTENTE_LIVRAISON = "EN_ATTENTE_LIVRAISON",
  /** @deprecated Phase 3 — porté par `EtatReception.PARTIELLEMENT`. */
  LIVREE_PARTIELLEMENT = "LIVREE_PARTIELLEMENT",
  /** @deprecated Phase 3 — annulation portée par `dateAnnulation` (flag réversible). */
  ANNULEE = "ANNULEE",
  TERMINEE = "TERMINEE",
  /** @deprecated Phase 4 — fusionné avec TERMINEE. */
  SOLDEE = "SOLDEE",
}
